
import { defineComponent, PropType } from 'vue'
import VideoThumbnail from '@/components/VideoThumbnail.vue'
import { VideoWatchHistoryAttributes } from '@/types/models/video-watch-history'
import { toArray } from '@/utils/array'

export default defineComponent({
  props: {
    watchHistories: {
      type: Array as PropType<VideoWatchHistoryAttributes[] | undefined>,
      'default': () => ([]),
    }
  },
  components: { VideoThumbnail },
  setup() {
    return {
      toArray,
    }
  },
})
